export const datasetStatusSupported = (supported = false, reasons = []) => ({ reasons, supported });

const datasetStatusInitialState = (supported = false, managed = true) => ({
  query_enabled: datasetStatusSupported(supported),
  request_enabled: datasetStatusSupported(supported),
  source_exists: datasetStatusSupported(supported),
  storage_enabled: datasetStatusSupported(supported),
  conditional_access: datasetStatusSupported(supported),
  managed_data: datasetStatusSupported(managed),
  request_workspace: datasetStatusSupported(supported),
});

export default datasetStatusInitialState;
